type CreditLimitArgs = {
  available?: number | null;
  negativeCreditAllowance?: number | null;
  lineItemsTotal: number;
};

export const isCreditLimitExceededByValuesOld = ({
  available,
  negativeCreditAllowance,
  lineItemsTotal,
}: CreditLimitArgs) => {
  if (available == null || negativeCreditAllowance == null) {
    return false;
  }

  const limit =
    negativeCreditAllowance > 0
      ? -negativeCreditAllowance
      : negativeCreditAllowance;

  return available - lineItemsTotal < limit;
};

export const isInNegativeCreditWarningZone = ({
  available,
  negativeCreditAllowance,
  lineItemsTotal,
}: CreditLimitArgs) => {
  if (available == null) {
    return false;
  }

  const exceedsAvailable = available - lineItemsTotal < 0;
  const exceedsNegativeLimit = isCreditLimitExceededByValues({
    available,
    negativeCreditAllowance,
    lineItemsTotal,
  });

  return exceedsAvailable && !exceedsNegativeLimit;
};

export const isCreditLimitExceededByValues = ({
  available,
  negativeCreditAllowance,
  lineItemsTotal,
}: CreditLimitArgs) => {
  if (available == null || negativeCreditAllowance == null) {
    return false;
  }

  const totalCredit = available + negativeCreditAllowance;

  // Customer has enough available credit to cover the order
  if (available >= lineItemsTotal) {
    return false;
  }

  // Customer does not have enough total credit to cover the order
  else if (totalCredit < lineItemsTotal) {
    return true;
  }

  // Customer has enough total credit to cover the order, but not enough available credit
  return false;
};
